// extracted by mini-css-extract-plugin
export default {"nav-title":"nav-title_nav-title__-ZpmJ"};